module.exports = __webpack_public_path__ + "static/media/view5.46fe244c.jpg";